import { ICourse, ICourseStat, IInterview, ILesson, IModule, IPaginateRequest, IQuestion, IQuestionAnswer, IQuestionApiInput, IQuestionOption, IQuiz, IQuizYear, ISearchRequest, IUserCourse, IUserInterview, IUserQuestionAnswer, IUserQuiz } from "utils/types";

export type IQuestionAnswerBluePrint = (keyof IQuestionAnswer)[]
export type IUserQuizBluePrint = (keyof IUserQuiz)[]
export type IUserQuestionAnswerBluePrint = (keyof IUserQuestionAnswer)[]
export type ICourseStatBluePrint = (keyof ICourseStat)[]
export type IQuestionBluePrint = (keyof IQuestion)[]
export type IQuestionOptionBluePrint = (keyof IQuestionOption)[]
export type IQuizYearBluePrint = (keyof IQuizYear)[]
export type ILessonBluePrint = (keyof ILesson)[]
export type ICourseModuleBluePrint = (keyof IModule)[]
export type IInterviewBluePrint = (keyof IInterview)[];
export type IUserInterviewBluePrint = (keyof IUserInterview)[];




export const userInterviewQuery:IUserInterviewBluePrint = [
    "completed", "createdAt", "id", "interviewId",
    "remark", "score", "totalScore", "userId",
]
export const interviewQuery:IInterviewBluePrint = [
    "description", "id", "questions", "title"
]

export const courseStatQuery:ICourseStatBluePrint = [
    "total", "premium", "free", "active", "totalQuizzes"
]
export const courseQuery:ICourseBluePrint = [
   "availableQuizzes", "category", "courseModules", "courseStatus",
   "courseStudyType", "courseType", "description", "id", "image", "isHidden",
   "learningObjectives", "mode", "prerequisites", "quizDescription", "quizPrepTips",
   "quizzes", "targetAudience", "title", "totalScore"
]
export const quizQuery:IQuizBluePrint = [
    "courseId", "description", "id", "questions", "title", "year"
]
export const userCourseQuery:IUserCourseBluePrint = [
    "completed", "completedCourseModuleIds", "courseId", "id", "score", "userId",
    "currentModuleId", "createdAt", "course"
]
export const userQuizQuery:IUserQuizBluePrint = [
    "answers", "completed", "id", "quizId", "quizMode", "userId", "score",
    "totalScore", "remark", "createdAt", "quiz"
]
export const courseModuleQuery:ICourseModuleBluePrint = [
    "activeKey", "description", "id", "index", "lessons", "title"
]
export const questionQuery:IQuestionBluePrint = [
    "id", "options", "content", "quizId", "interviewId", "allowMultiple"
]
export const questionOptionQuery:IQuestionOptionBluePrint = [
    "id", "text"
]
export const quizYearQuery:IQuizYearBluePrint = [
    "quizId", "quizYear", "totalQuestions"
]
export const lessonQuery:ILessonBluePrint = [
    "content", "id", "index", "moduleId", "title"
]
export const questionAnswerQuery:IQuestionAnswerBluePrint = [
    "explanation", "id", "optionIds", "questionId", "quizId"
]
export const userQuestionAnswerQuery:IUserQuestionAnswerBluePrint = [
    "id", "optionIds", "questionId", "quizId"
]

// blue prints 
export const _getQuestionResponseBluePrint:Omit<IGetQuestionResponseBluePrint, "question"> = {
    options: questionOptionQuery
}
export const getQuestionsResponseBluePrint:IGetQuestionsResponseBluePrint = {
    questions: questionQuery,
    ..._getQuestionResponseBluePrint
}
export const _getCourseModuleResponseBluePrint:Omit<IGetCourseModuleResponseBluePrint, "courseModule"> = {
    lessons: lessonQuery
}
export const getCourseModuleResponseBluePrint:IGetCourseModuleResponseBluePrint = {
    courseModule: courseModuleQuery,
    ..._getCourseModuleResponseBluePrint
}
export const getCourseModulesResponseBluePrint:IGetCourseModulesResponseBluePrint = {
    courseModules: courseModuleQuery,
    ..._getCourseModuleResponseBluePrint
}
export const _getQuizResponseBluePrint:Omit<IGetQuizResponseBluePrint, "quiz"> = {
    ...getQuestionsResponseBluePrint,
    options: questionOptionQuery
}
export const getQuizResponseBluePrint:IGetQuizResponseBluePrint = {
    quiz: quizQuery,
    ..._getQuizResponseBluePrint
}

export const getQuizzesResponseBluePrint:IGetQuizzesResponseBluePrint = {
    quizzes: quizQuery,
    ..._getQuizResponseBluePrint,
}
export const _getCourseResponseBluePrint:Omit<IGetCourseResponseBluePrint, "course"> = {
    availableQuizzes: quizYearQuery,
    ...getQuizzesResponseBluePrint,
    ...getCourseModulesResponseBluePrint
}
export const getCourseResponseBluePrint:IGetCourseResponseBluePrint = {
    course: courseQuery,
    ..._getCourseResponseBluePrint
}
export const getCoursesResponseBluePrint:IGetCoursesResponseBluePrint = {
    courses: courseQuery,
    ..._getCourseResponseBluePrint,
}
export const _getUserCourseResponseBluePrint:Omit<IGetUserCourseResponseBluePrint, "userCourse"> = {
    ...getCourseResponseBluePrint
}
export const getUserCourseResponseBluePrint:IGetUserCourseResponseBluePrint = {
    userCourse: userCourseQuery,
    ..._getUserCourseResponseBluePrint
}
export const getUserCoursesResponseBluePrint:IGetUserCoursesResponseBluePrint = {
    userCourses: userCourseQuery,
    ..._getUserCourseResponseBluePrint
}
export const _getUserQuizResponseBluePrint:Omit<IGetUserQuizResponseBluePrint, "userQuiz"> = {
    ...getQuizResponseBluePrint,
    answers: userQuestionAnswerQuery
}
export const getUserQuizResponseBluePrint:IGetUserQuizResponseBluePrint = {
    userQuiz: userQuizQuery,
    ..._getUserQuizResponseBluePrint
}
export const getUserQuizzesResponseBluePrint:IGetUserQuizzesResponseBluePrint = {
    userQuizzes: userQuizQuery,
    ..._getUserQuizResponseBluePrint
}
export const _getUserQuestionAnswerResponseBluePrint:Omit<IGetUserQuestionAnswerResponseBluePrint, "userQuestionAnswer"> = {
    
}
export const getUserQuestionAnswersResponseBluePrint:IGetUserQuestionAnswersResponseBluePrint = {
    userQuestionAnswers: userQuestionAnswerQuery,
    ..._getUserQuestionAnswerResponseBluePrint,
}
export const getQuestionAnswersResponseBluePrint:IGetQuestionAnswersResponseBluePrint = {
    questionAnswers: questionAnswerQuery
}



// user interviews

export interface IGetUserInterviewRequest {
    userInterview: Partial<IUserInterview>
}
export interface IGetUserInterviewResponse {
    userInterview: IUserInterview;
}
export const getUserInterviewResponse:(keyof IGetUserInterviewResponse)[] = [
    "userInterview"
]
export interface IGetUserInterviewResponseBluePrint {
    userInterview: IUserInterviewBluePrint;
}
export const getUserInterviewResponseBluePrint:IGetUserInterviewResponseBluePrint = {
    "userInterview": userInterviewQuery
}

export interface IScoreInterviewRequest {
    userInterview: Partial<IUserInterview>;
    userQuestionAnswers: Partial<IUserQuestionAnswer>[]
}
export type IScoreInterviewResponse = IGetUserInterviewResponse
export const getScoreInterviewResponse: (keyof IScoreInterviewResponse)[] = getUserInterviewResponse;
export type IScoreInterviewResponseBluePrint = IGetUserInterviewResponseBluePrint
export const getScoreInterviewResponseBluePrint:IScoreInterviewResponseBluePrint = getUserInterviewResponseBluePrint;

export interface IGetUserInterviewsRequest {
    search?: string;
    userInterview?: Partial<IUserInterview>;
    userInterviewIds?: string[];
    limit: number;
    skip: number;
}
export interface IGetUserInterviewsResponse {
    userInterviews: IUserInterview[];
}
export const getUserInterviewsResponse: (keyof IGetUserInterviewsResponse)[] = [
    "userInterviews"
]
export interface IGetUserInterviewsResponseBluePrint {
    userInterviews: IUserInterviewBluePrint;
}
export const getUserInterviewsResponseBluePrint:IGetUserInterviewsResponseBluePrint = {
    userInterviews: userInterviewQuery
}
// get userInterview 
export type ICreateUserInterviewRequest = IGetUserInterviewRequest;
export type ICreateUserInterviewResponse = IGetUserInterviewResponse;
export const createUserInterviewResponse:(keyof ICreateUserInterviewResponse)[] = getUserInterviewResponse
export type ICreateUserInterviewResponseBluePrint = IGetUserInterviewResponseBluePrint
export const createUserInterviewResponseBluePrint:ICreateUserInterviewResponseBluePrint = getUserInterviewResponseBluePrint

export interface IUpdateUserInterviewRequest {
    userInterviewId: string;
    userInterview: Partial<IUserInterview>;
}
export type IUpdateUserInterviewResponse = IGetUserInterviewResponse;
export const updateUserInterviewResponse = getUserInterviewResponse;
export type IUpdateUserInterviewResponseBluePrint = IGetUserInterviewResponseBluePrint;
export const updateUserInterviewResponseBluePrint = getUserInterviewResponseBluePrint;

export interface IDeleteUserInterviewRequest {
    userInterviewId: string;
}
export type IDeleteUserInterviewResponse = IDeleteUserInterviewRequest;
export const deleteUserInterviewResponse: (keyof IDeleteUserInterviewResponse)[] = [
    "userInterviewId"
]


// interviews
export interface IGetInterviewRequest {
    interview: Partial<IInterview>
}
export interface IGetInterviewResponse {
    interview: IInterview;
}
export const getInterviewResponse:(keyof IGetInterviewResponse)[] = [
    "interview"
]
export interface IGetInterviewResponseBluePrint {
    interview: IInterviewBluePrint;
    questions: IQuestionBluePrint
    options: IQuestionOptionBluePrint
}
export const _getInterviewResponseBluePrint: Omit<IGetInterviewResponseBluePrint, "interview"> = {
    questions: questionQuery,
    options: questionOptionQuery,
}
export const getInterviewResponseBluePrint:IGetInterviewResponseBluePrint = {
    interview: interviewQuery,
   ..._getInterviewResponseBluePrint,
}

export interface IUpdateInterviewUnifiedRequest {
    interviewId: string;
    updateInterviewRequest?: IUpdateInterviewRequest;
    updateQuestionRequest?: IUpdateQuestionRequest[];
    updateQuestionOptionRequest?: IUpdateQuestionOptionRequest[];
    updateQuestionAnswerRequest?: IUpdateQuestionAnswerRequest[];
    addQuestionRequest?: ICreateQuestionRequest[];
    addQuestionOptionRequest?: IAddQuestionOptionRequest[];
    addQuestionAnswerRequest?: IAddQuestionAnswerRequest[];
}
export type IUpdateInterviewUnifiedResponse = IGetInterviewResponse;
export type IUpdateInterviewUnifiedResponseBluePrint = IGetInterviewResponseBluePrint;
export const updateInterviewUnifiedResponseBluePrint: IUpdateInterviewUnifiedResponseBluePrint = getInterviewResponseBluePrint



export interface IGetInterviewsRequest {
    search?: string;
    interview?: Partial<IInterview>;
    interviewIds?: string[];
    limit: number;
    skip: number;
}
export interface IGetInterviewsResponse {
    interviews: IInterview[];
}
export const getInterviewsResponse: (keyof IGetInterviewsResponse)[] = [
    "interviews"
]
export interface IGetInterviewsResponseBluePrint extends Omit<IGetInterviewResponseBluePrint, "interview">{
    interviews: IInterviewBluePrint;
}
export const getInterviewsResponseBluePrint:IGetInterviewsResponseBluePrint = {
    interviews: interviewQuery,
    ..._getInterviewResponseBluePrint,
}
// get interview 
export interface ICreateInterviewRequest {
    interview: Partial<IInterview>;
    questionRequests: ICreateQuestionRequest[];
    questionAnswers: Partial<IQuestionAnswer>[]   
}
export type ICreateInterviewResponse = IGetInterviewResponse;
export const createInterviewResponse:(keyof ICreateInterviewResponse)[] = getInterviewResponse
export type ICreateInterviewResponseBluePrint = IGetInterviewResponseBluePrint
export const createInterviewResponseBluePrint:ICreateInterviewResponseBluePrint = getInterviewResponseBluePrint

export interface IUpdateInterviewRequest {
    interviewId: string;
    interview: Partial<IInterview>;
}
export type IUpdateInterviewResponse = IGetInterviewResponse;
export const updateInterviewResponse = getInterviewResponse;
export type IUpdateInterviewResponseBluePrint = IGetInterviewResponseBluePrint;
export const updateInterviewResponseBluePrint = getInterviewResponseBluePrint;

export interface IDeleteInterviewRequest {
    interviewId: string;
}
export type IDeleteInterviewResponse = IDeleteInterviewRequest;
export const deleteInterviewResponse: (keyof IDeleteInterviewResponse)[] = [
    "interviewId"
]



// quiz

export interface IGetQuizYearsRequest {
    courseId: string;
}
export interface IGetQuizYearsResponse {
    quizYears: IQuizYear[]
}
export interface IGetQuizYearsResponseBluePrint {
    quizYears: IQuizYearBluePrint
}
export interface IDeleteQuestionOptionRequest {
    questionOptionId: string;
}
export interface IDeleteQuestionOptionResponse {
    questionOptionId: string;
}
export interface ICreateQuestionRequest {
    question: Partial<IQuestion>;
    questionOptions: Partial<IQuestionOption>[]
}
export interface ICreateQuestionResponse {
    question: IQuestion
}

// Quiz 
 /**
 * quizId: String!
    updateQuizRequest: UpdateQuizRequestInput
    updateQuestionRequest: [UpdateQuestionRequestInput]
    updateQuestionOptionRequest: [UpdateQuestionOptionRequestInput]
    updateQuestionAnswerRequest: [UpdateQuestionAnswerRequestInput]
    addQuestionRequest: [AddQuestionRequestInput]
    addQuestionOptionRequest: [AddQuestionOptionRequestInput]
    addQuestionAnswerRequest: [AddQuestionAnswerRequestInput]
    */
export interface IUpdateQuizRequest {
    quizId: string;
    quiz: Partial<IQuiz>;
}
export interface IUpdateQuestionRequest {
    questionId: string;
    question: Partial<IQuestion>;
}
export interface IUpdateQuestionOptionRequest {
    questionOptionId: string;
    questionOption: Partial<IQuestionOption>;
}
export interface IUpdateQuestionAnswerRequest {
    questionAnswer: Partial<IQuestionAnswer>;
    questionAnswerId: string;
}
export interface IAddQuestionOptionRequest {
    questionOption: Partial<IQuestionOption>;
}
export interface IAddQuestionAnswerRequest {
    questionAnswer: Partial<IQuestionAnswer>;
}
export interface IUpdateQuizUnifiedRequest {
    quizId: string;
    updateQuizRequest?: IUpdateQuizRequest;
    updateQuestionRequest?: IUpdateQuestionRequest[];
    updateQuestionOptionRequest?: IUpdateQuestionOptionRequest[];
    updateQuestionAnswerRequest?: IUpdateQuestionAnswerRequest[];
    addQuestionRequest?: ICreateQuestionRequest[];
    addQuestionOptionRequest?: IAddQuestionOptionRequest[];
    addQuestionAnswerRequest?: IAddQuestionAnswerRequest[];
}
export type IUpdateQuizUnifiedResponse = IGetQuizResponse;
export type IUpdateQuizUnifiedResponseBluePrint = IGetQuizResponseBluePrint;
export interface IScoreQuizRequest {
    userQuiz: Partial<IUserQuiz>;
    userQuestionAnswers: Partial<IUserQuestionAnswer>[]
}
export interface IScoreQuizResponse {
    userQuiz: IUserQuiz
}
export type IScoreQuizResponseBluePrint = IGetUserQuizResponseBluePrint

export interface ICreateQuizRequest {
    quiz: Partial<IQuiz>;
    questionRequests: ICreateQuestionRequest[];
    questionAnswers: Partial<IQuestionAnswer>[]
}
export interface ICreateQuizResponse {
    quiz: IQuiz
}
export type ICreateQuizResponseBluePrint = IGetQuizResponseBluePrint;
export interface IDeleteQuizAndGetQuizYearsRequest {
    quizId: string;
    courseId: string;
}
export interface IDeleteQuizAndGetQuizYearsResponse {
    quizYears: IQuizYear[]
}
export interface IDeleteQuizAndGetQuizYearsResponseBluePrint {
    quizYears: IQuizYearBluePrint;
}
export interface IGetQuizzesRequest extends IPaginateRequest, ISearchRequest{
    quizIds?: string[];
    quiz?: Partial<IQuiz>;
}
export interface IGetQuizzesResponse {
    quizzes: IQuiz[]
}
export interface IGetQuizzesResponseBluePrint extends Omit<IGetQuizResponseBluePrint, "quiz">{
    quizzes: IQuizBluePrint
}
export interface IGetQuizRequest {
    quiz: Partial<IQuiz>;
}
export interface IGetQuizResponse {
    quiz: IQuiz
}

export interface IGetQuizResponseBluePrint {
    quiz: IQuizBluePrint
    questions: IQuestionBluePrint
    options: IQuestionOptionBluePrint
}

export interface IGetUserQuizzesRequest extends IPaginateRequest, ISearchRequest{
    userQuizIds?: string[];
    userQuiz?: Partial<IUserQuiz>;
}
export interface IGetUserQuizzesResponse {
    userQuizzes: IUserQuiz[]
}
export interface IGetUserQuizzesResponseBluePrint extends Omit<IGetUserQuizResponseBluePrint, "userQuiz"> {
    userQuizzes: IUserQuizBluePrint
}

// TODO: implement other user quiz
export interface IGetUserQuizResponseBluePrint {
    userQuiz: IUserQuizBluePrint
    quiz: IQuizBluePrint;
    answers: IUserQuestionAnswerBluePrint
}

export interface IGetUserQuestionAnswersRequest extends ISearchRequest, IPaginateRequest {
    userQuestionAnswer?: Partial<IUserQuestionAnswer>;
    userQuestionAnswerIds?: string[];
}
export interface IGetUserQuestionAnswersResponse {
    userQuestionAnswers: IUserQuestionAnswer[];
}
export interface IGetUserQuestionAnswersResponseBluePrint extends Omit<IGetUserQuestionAnswerResponseBluePrint, "userQuestionAnswer"> {
    userQuestionAnswers: IUserQuestionAnswerBluePrint
}
export interface IGetUserQuestionAnswerResponseBluePrint {
    userQuestionAnswer: IUserQuestionAnswerBluePrint
}




export interface IDeleteCourseModuleRequest {
    courseModuleId: string
}
export interface IDeleteCourseModuleResponse {
    courseModuleId: string
}


export interface IUpdateCourseModulesRequest {
    courseModuleUpdateRequests: IUpdateCourseModuleRequest[];
}
export interface IUpdateCourseModulesResponse {
    courseModuleIds: string[]
}
export interface IUpdateCourseModuleRequest {
    courseModuleId: string;
    courseModule: Partial<IModule>;
}
export type IUpdateCourseModuleResponse = IGetCourseModuleResponse
export type IUpdateCourseModuleResponseBluePrint = IGetCourseModuleResponseBluePrint

export interface IAddCourseModulesRequest {
    courseModuleAddRequests: IAddCourseModuleRequest[]
}
export interface IAddCourseModulesResponse {
    courseModuleIds: string[]
}
export interface IAddCourseModuleRequest {
    courseModule: Partial<IModule>;
    lessons: Partial<ILesson>[]
}
export type IAddCourseModuleResponse = IGetCourseModuleResponse;
export type IAddCourseModuleResponseBluePrint = IGetCourseModuleResponseBluePrint

export interface IGetCourseModulesRequest extends IPaginateRequest, ISearchRequest{
    courseModuleIds?: string[];
    courseModule?: Partial<IModule>;
}
export interface IGetCourseModulesResponse {
    courseModules: IModule[]
}export interface IGetCourseModulesResponseBluePrint
extends Omit<IGetCourseModuleResponseBluePrint, "courseModule">{
    courseModules: ICourseModuleBluePrint
}
export interface IGetCourseModuleRequest {
    courseModule: Partial<IModule>;
}
export interface IGetCourseModuleResponse {
    courseModule: IModule
}
export interface IGetCourseModuleResponseBluePrint extends IGetLessonsResponseBluePrint {
    courseModule: ICourseModuleBluePrint
}
export interface IGetCourseModuleCountRequest {
    courseModule: Partial<IModule>
}
export interface IGetCourseModuleCountResponse {
    moduleCount: number;
}

// lessons 
export interface IUpdateLessonsRequest {
    lessonUpdateRequests: IUpdateLessonRequest[]
}
export interface IUpdateLessonsResponse {
    lessonIds: string[]
}
export interface IUpdateLessonRequest {
    lessonId: string;
    lesson: Partial<ILesson>
}
export interface IUpdateLessonResponse {
    lesson: ILesson
}
export type IUpdateLessonResponseBluePrint = IGetLessonResponseBluePrint
export interface IGetLessonsRequest extends IPaginateRequest, ISearchRequest{
    lessonIds?: string[];
    lesson?: Partial<ILesson>;
}
export interface IGetLessonsResponse {
    lessons: ILesson[]
}
export interface IGetLessonsResponseBluePrint extends Omit<IGetLessonResponseBluePrint, "lesson">{
    lessons: ILessonBluePrint
}
export interface IGetLessonRequest {
    lesson: Partial<ILesson>;
}
export interface IGetLessonResponse {
    lesson: ILesson
}
export interface IGetLessonResponseBluePrint {
    lesson: ILessonBluePrint
}
export interface IAddLessonsRequest {
    lessons: Partial<ILesson>[]
}
export interface IAddLessonsResponse {
    lessonIds: string[]
}
export interface IAddLessonRequest {
    lesson: Partial<ILesson>
}
export type IAddLessonResponse = IGetLessonResponse;
export type IAddLessonResponseBluePrint = IGetLessonResponseBluePrint;

// user courses
export type IUserCourseBluePrint = (keyof IUserCourse)[]   

export interface ICreateUserCourseRequest {
    userCourse: Partial<IUserCourse>;
}
export interface ICreateUserCourseResponse {
    userCourse: IUserCourse;
}
export type ICreateUserCourseResponseBluePrint = IGetUserCourseResponseBluePrint;
export interface IUpdateUserCourseRequest {
    userCourseId: string;
    userCourse: Partial<IUserCourse>;   
}
export interface IUpdateUserCourseResponse {
    userCourse: IUserCourse
}
export type IUpdateUserCourseResponseBluePrint = IGetUserCourseResponseBluePrint;

export interface IGetUserCoursesRequest extends IPaginateRequest, ISearchRequest{
    userCourseIds?: string[];
    userCourse?: Partial<IUserCourse>;
}
export interface IGetUserCoursesResponse {
    userCourses: IUserCourse[]
}
export interface IGetUserCoursesResponseBluePrint extends Omit<IGetUserCourseResponseBluePrint, "userCourse">{
    userCourses: IUserCourseBluePrint
}
export interface IGetUserCourseRequest {
    userCourse: Partial<IUserCourse>;
}
export interface IGetUserCourseResponse {
    userCourse: IUserCourse
}
export interface IGetUserCourseResponseBluePrint extends IGetCourseResponseBluePrint {
    userCourse: IUserCourseBluePrint
}

// Courses
export interface ICreateCourseRequest {
    course: Partial<ICourse>;
    courseModulesRequest: IAddCourseModuleRequest[];
}
export interface ICreateCourseResponse {
    course: ICourse
}
export type ICreateCourseResponseBluePrint = IGetCourseResponseBluePrint

export interface IUpdateCourseRequest{
    courseId: string;
    course: Partial<ICourse>;
}
export interface IUpdateCourseResponse {
    course: ICourse;
}
export type IUpdateCourseResponseBluePrint = IGetCourseResponseBluePrint;
export interface IGetRecommendedCoursesRequest {
    userId: string;
}
export interface IGetRecommendedCoursesResponse {
    courses: ICourse[]
}
export type IGetRecommendedCoursesResponseBluePrint = IGetCoursesResponseBluePrint
export interface IGetCourseRequest {
    course: Partial<ICourse>;       
}
export interface IGetCourseResponse {
    course: ICourse
}
export interface IGetCourseResponseBluePrint 
extends IGetQuizzesResponseBluePrint, 
Omit<IGetQuizYearsResponseBluePrint, "quizYears">,
IGetCourseModulesResponseBluePrint {
    course: ICourseBluePrint;
    availableQuizzes: IQuizYearBluePrint;
}
export interface IGetCoursesRequest extends IPaginateRequest, ISearchRequest{
    course?: Partial<ICourse>;
    courseIds?: string[];
}
export interface IGetCoursesResponse {
    courses: ICourse[];
}
export interface IGetCoursesResponseBluePrint extends Omit<IGetCourseResponseBluePrint, "course">{
    courses: ICourseBluePrint;
}
export interface IDeleteCourseRequest {
    courseId: string;
}
export interface IDeleteCourseResponse {
    courseId: string;
}

// Question Ansers 


export interface IGetQuestionAnswersRequest extends IPaginateRequest, ISearchRequest{
    questionAnswerIds?: string[];
    questionAnswer?: Partial<IQuestionAnswer>;
}
export interface IGetQuestionAnswersResponse {
    questionAnswers: IQuestionAnswer[]
}
export interface IGetQuestionAnswersResponseBluePrint extends Omit<IGetQuestionAnswerResponseBluePrint, "questionAnswer">{
    questionAnswers: IQuestionAnswerBluePrint
}
export interface IGetQuestionAnswerRequest {
    questionAnswer: Partial<IQuestionAnswer>;
}
export interface IGetQuestionAnswerResponse {
    questionAnswer: IQuestionAnswer
}
export interface IGetQuestionAnswerResponseBluePrint {
    questionAnswer: IQuestionAnswerBluePrint
}

// Questions 
export interface IGetQuestionsRequest extends IPaginateRequest, ISearchRequest{
    questionIds?: string[];
    question?: Partial<IQuestion>;
}
export interface IGetQuestionsResponse {
    questions: IQuestion[]
}
export interface IGetQuestionsResponseBluePrint extends Omit<IGetQuestionResponseBluePrint, "question">{
    questions: IQuestionBluePrint
}
export interface IGetQuestionRequest {
    question: Partial<IQuestion>;
}
export interface IGetQuestionResponse {
    question: IQuestion
}
export interface IGetQuestionResponseBluePrint {
    question: IQuestionBluePrint
}
export interface IDeleteQuestionsByQuizIdRequest {
    quizId: string;
}
export interface IDeleteQuestionsByQuizIdResponse {
    quizId: string;
}


export type ICourseBluePrint = (keyof ICourse)[]
export type IQuizBluePrint = (keyof IQuiz)[]

export interface IGetCourseStatRequest {
}
export interface IGetCourseStatResponse {
    courseStat: ICourseStat
}
export interface IGetCourseStatResponseBluePrint {
    courseStat: ICourseStatBluePrint
}